var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"info-flow"}},[_vm._v(" 这是信息流界面 ")])}
var staticRenderFns = []

export { render, staticRenderFns }